import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { featureFlagActions } from 'store/featureFlagSlice/featureFlagSlice';
import { selectSsoEnabled, selectForgotPwdEnabled, selectKeycloakIntegrationEnabled } from 'store/featureFlagSlice/featureFlagSelectors';

export const useFeatureFlag = () => {
    const dispatch = useDispatch();
    const isSSOEnabled = useSelector(selectSsoEnabled);
    const isForgotPwdEnabled = useSelector(selectForgotPwdEnabled);
    const isKeycloakIntegrationEnabled = useSelector(selectKeycloakIntegrationEnabled);

    useEffect(() => {
        if (isSSOEnabled === null && isForgotPwdEnabled === null) {
            dispatch(featureFlagActions.getFeatureFlagData());
        }
    }, [dispatch, isSSOEnabled, isForgotPwdEnabled, isKeycloakIntegrationEnabled]);

    return { isSSOEnabled, isForgotPwdEnabled, isKeycloakIntegrationEnabled };
};
